<template>
  <div>
    <div>
      <v-container>
        <div class="text-xs-right">
          <v-btn @click="clickNotify" icon outline color="primary"
            ><i class="fas fa-bell"></i
          ></v-btn>
        </div>
        <v-layout>
          <v-flex>
            <div>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <div class="form-control" style="position: relative">
                        <div class="labelinputontop">Start date</div>
                        <DatePickerWithoutButton v-model="selectedDate.start">
                          <input readonly :value="dateFormat(selectedDate.start)" type="text" />
                        </DatePickerWithoutButton>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <div class="form-control" style="position: relative">
                        <div class="labelinputontop">End date</div>
                        <DatePickerWithoutButton v-model="selectedDate.end">
                          <input readonly :value="dateFormat(selectedDate.end)" type="text" />
                        </DatePickerWithoutButton>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs7>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <div>
                        <div class="form-control">
                          <div style="position: relative">
                            <input
                              class="mb-0"
                              placeholder="Search"
                              v-model="input.search"
                              type="text"
                            />
                            <v-btn
                              style="position: absolute; right: 5px; top: 5px"
                              class="ma-0"
                              icon
                              ><v-icon color="primary">search</v-icon></v-btn
                            >
                          </div>
                        </div>
                      </div></v-flex
                    >
                    <v-flex xs6
                      ><exportxlsx></exportxlsx>
                      <v-btn outline color="primary">
                        <i class="fa fa-plus middle"></i>ADD</v-btn
                      ></v-flex
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <div>
                Sort by
                <DropdownMenu :outtericon="true" v-model="selectedSort" :options="optionsSort">
                  <span style="font-weight: bold">{{ selectedSort }}</span>
                </DropdownMenu>
              </div>
            </div>
            <div>
              <div class="my-3 pa-3" style="background-color: #eee; border-radius: 10px">
                <TicketItem></TicketItem>
              </div></div
          ></v-flex>

          <v-flex xs3 v-if="panel">
            <div v-if="panel == 'notify'">
              <div class="pa-3 ml-2" style="background-color: #eee">
                <div>
                  <div class="text-xs-right caption">dd/mm/yyyy</div>
                  <div style="font-size: 14px">
                    คุณได้รับการ assign ticket จากระบบ Ticket ID #144 <br />
                    ลูกค้า: Mookodhod <br />
                    เรื่อง: ติดต่อเจ้าหน้าที่
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="panel == 'filter'">
              <div class="pa-3 ml-2" style="background-color: #eee">
                <div>
                  <div class="text-xs-right caption">dd/mm/yyyy</div>
                  <div style="font-size: 14px">
                    คุณได้รับการ assign ticket จากระบบ Ticket ID #144 <br />
                    ลูกค้า: Mookodhod <br />
                    เรื่อง: ติดต่อเจ้าหน้าที่
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import TicketItem from './TicketItem.vue'
export default {
  components: {
    DatePickerWithoutButton,
    exportxlsx,
    DropdownMenu,
    TicketItem,
  },
  data() {
    return {
      selectedSort: 'Due by time',
      optionsSort: ['Due by time', 'Created date', 'Priority', 'Status'],
      input: {
        search: '',
      },
      panel: '',
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
      },
    }
  },
  methods: {
    clickNotify() {
      if (this.panel == 'notify') {
        this.panel = ''
      } else {
        this.panel = 'notify'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.labelinputontop {
  position: absolute;
  top: -9px;
  left: 12px;
  font-size: 14px;
  color: #8c8c8c;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/view/ticket2/management/Management.vue